module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('prb-toolbar', {
    attrs: {
      "disable": !_vm.terms
    }
  }), _vm._v(" "), _c('prb-terms', {
    attrs: {
      "termsDialog": !_vm.terms
    }
  }), _vm._v(" "), _c('main', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "tutorial__layout"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "tutorial__layout-card"
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('div', {
    staticClass: "top__layout-title"
  }, [_vm._v("Tutorial")])]), _vm._v(" "), _c('v-card-text', [_c('span', {
    staticClass: "title"
  }, [_vm._v("Video")]), _vm._v(" "), _c('div', {
    staticClass: "video"
  }, [_c('div', {
    staticClass: "iframe-wrapper"
  }, [_c('iframe', {
    attrs: {
      "src": "https://drive.google.com/file/d/1OOobo7FuDIvLSNLXOfA7bqnjbKpxom-B/preview",
      "frameborder": "0",
      "webkitallowfullscreen": "",
      "mozallowfullscreen": "",
      "allowfullscreen": ""
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Figures")]), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-3 blue-grey lighten-5",
    staticStyle: {
      "border-radius": "5px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pl-3 pr-3 pt-2",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('img', {
    staticClass: "pa-1 white",
    staticStyle: {
      "width": "100%",
      "border-radius": "5px"
    },
    attrs: {
      "src": require("../img/s5.png")
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-5 pl-3 pt-3 pb-1",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('span', {
    staticClass: "body-2"
  }, [_vm._v("\n                      Flow diagram illustrating the logic for the calculation of the scores, related to STAR Methods.\n                    ")])])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2 blue-grey lighten-5",
    staticStyle: {
      "border-radius": "5px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pl-3 pr-3 pt-2",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('img', {
    staticClass: "pa-1 white",
    staticStyle: {
      "width": "100%",
      "border-radius": "5px"
    },
    attrs: {
      "src": require("../img/PIK3CB_Snapshot.png")
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-5 pl-3 pt-3 pb-1",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('span', {
    staticClass: "body-2"
  }, [_vm._v("\n                      Snapshot of the target overview page of the Probe Miner resource for the target PIK3CB.\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "body-1"
  }, [_vm._v("\n                      As it can be observed the first probe according to the pre-defined weights for the Global Score is pictilisib. However, a red warning highlights lack of 10-fold selectivity. This probe is also covered by The Chemical Probes Portal and it is thus highlighted in a differential blue colour, the expert star rating is displayed and appropriate links to The Chemical Probes Portal are provided to facilitate the navigation between the two resources.\n                    ")])])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2 blue-grey lighten-5",
    staticStyle: {
      "border-radius": "5px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pl-3 pr-3 pt-2",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('img', {
    staticClass: "pa-1 white",
    staticStyle: {
      "width": "100%",
      "border-radius": "5px"
    },
    attrs: {
      "src": require("../img/ExampleOfHowToUseTheResource_v5.png")
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-5 pl-3 pt-3 pb-1",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('span', {
    staticClass: "body-2"
  }, [_vm._v("\n                      Probe Miner Resource Documentation on how to use the resource.\n                    ")])])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2 blue-grey lighten-5",
    staticStyle: {
      "border-radius": "5px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pl-3 pr-3 pt-2",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('img', {
    staticClass: "pa-1 white",
    staticStyle: {
      "width": "100%",
      "border-radius": "5px"
    },
    attrs: {
      "src": require("../img/Documentation_v1_SFig5_v3.jpg")
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-5 pl-3 pt-3 pb-1",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('span', {
    staticClass: "body-2"
  }, [_vm._v("\n                      Probe Miner Resource Documentation on the Overview page.\n                    ")])])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2 blue-grey lighten-5",
    staticStyle: {
      "border-radius": "5px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pl-3 pr-3 pt-2",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('img', {
    staticClass: "pa-1 white",
    staticStyle: {
      "width": "100%",
      "border-radius": "5px"
    },
    attrs: {
      "src": require("../img/Documentation_v1_SFig8_v4.jpg")
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-5 pl-3 pt-3 pb-1",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('span', {
    staticClass: "body-2"
  }, [_vm._v("\n                      Probe Miner Resource Documentation on the customisation of the Global Score.\n                    ")])])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2 blue-grey lighten-5",
    staticStyle: {
      "border-radius": "5px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pl-3 pr-3 pt-2",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('img', {
    staticClass: "pa-1 white",
    staticStyle: {
      "width": "100%",
      "border-radius": "5px"
    },
    attrs: {
      "src": require("../img/Documentation_v1_SFig6_v2.jpg")
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-5 pl-3 pt-3 pb-1",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('span', {
    staticClass: "body-2"
  }, [_vm._v("\n                      Probe Miner Resource Documentation on the Chemical Tool Synopsis page.\n                    ")])])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2 blue-grey lighten-5",
    staticStyle: {
      "border-radius": "5px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pl-3 pr-3 pt-2",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('img', {
    staticClass: "pa-1 white",
    staticStyle: {
      "width": "100%",
      "border-radius": "5px"
    },
    attrs: {
      "src": require("../img/Documentation_v1_SFig7_v2.jpg")
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-5 pl-3 pt-3 pb-1",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('span', {
    staticClass: "body-2"
  }, [_vm._v("\n                      Probe Miner Resource Documentation on the Chemical Probes Table page.\n                    ")])])], 1)], 1), _vm._v(" "), _c('v-divider')], 1)], 1)])], 1)], 1)], 1), _vm._v(" "), _c('prb-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-664547cd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PrbTutorial.vue
// module id = 563
// module chunks = 1